import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  showCalltouchWidget(): void {
    if (typeof window?.ct === 'function') {
      window?.ct('modules', 'widgets', 'openExternal', 'callback', function (result: any) {
        if (result.error) {
          console.log(result);
        }
      });
    } else {
      console.error('ct method is not defined on window object.');
    }
  }

  isOldHeader(): boolean {
    return false;
  }
}
